import { PageEvents } from '@griply/types';
import React, { useRef } from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';

import { MobileAddTaskButton } from './components/mobile-add-task-button';
import { PageTopBar } from './components/page-top-bar';
import { TasksList } from './components/tasks-list';
import * as Styled from './inbox.style';

export const Inbox: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  useTrackPageVisitEvent(PageEvents.Inbox, undefined);

  return (
    <Styled.Container>
      <Styled.Main>
        <VirtualizedTreeListProvider>
          <Styled.MainContent>
            <PageTopBar />
            <Styled.Content ref={scrollRef}>
              <TasksList scrollRef={scrollRef} />
            </Styled.Content>
          </Styled.MainContent>
        </VirtualizedTreeListProvider>
      </Styled.Main>

      <MobileAddTaskButton />
    </Styled.Container>
  );
};
